module.exports = __webpack_public_path__ + "img/menu1.a6d42d28.svg";